import React from 'react';
import PropTypes from 'prop-types';
import ShowValue from './ShowValue';
import style from './style.css';

const Callout = props => {
    const { title, description, colors } = props.settings;

    return (
        <div
            className={style.wrapper}
            style={
                colors
                    ? {
                          border: `1px solid ${colors.primary}`,
                      }
                    : {}
            }
        >
            <div
                className={style.title}
                style={
                    colors
                        ? {
                              backgroundColor: colors.primary,
                          }
                        : {}
                }
            >
                {title}
            </div>
            <div className={style.description}>{description}</div>
            <div className={style.component}>
                <ShowValue data={props.data} colors={colors} />
            </div>
        </div>
    );
};

Callout.propTypes = {
    settings: PropTypes.object,
    handle: PropTypes.string,
    data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Callout.defaultProps = {};

export default Callout;
